import { tw } from '@/lib/utils'

interface AnonymousAvatarProps {
  size?: number
  className?: string
}

/** Stand-in for reviewers without a profile picture. Kept quiet (navy at
 *  20%) so lapis stays reserved for the stars and actions beside it. */
export const AnonymousAvatar = ({ size = 48, className }: AnonymousAvatarProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 666.6 666.6"
    width={size}
    height={size}
    className={tw('text-navy-20', className)}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M333.3,0C149.2,0,0,149.2,0,333.3s149.2,333.3,333.3,333.3,333.3-149.2,333.3-333.3S517.4,0,333.3,0ZM333.3,133.3c55.2,0,100,44.8,100,100s-44.8,100-100,100-100-44.8-100-100,44.8-100,100-100ZM529.8,514.9c.0184-.0367.0281-.0562.0422-.0844l-.0422.0844v.3c-.1,0-.4.5-.4.5-.2.4-.4.8-.7,1.3-.6,1-1.3,2.3-2.2,3.7-1.9,2.9-4.5,6.6-8,10.9-7.1,8.5-17.8,19.1-33.2,29.3-31.1,20.7-79.3,38.9-151.8,38.9-122.8,0-174.5-52.3-191.1-76.3-10.1-14.5-8.9-31.4-2.9-43.6,24.5-49.1,74.7-80.1,129.6-80.1h123.2c58.3,0,111.6,32.9,137.7,85.1l-.2.2c4.7,9.4,4.7,20.4,0,29.8Z"
    />
  </svg>
)
